export default __webpack_public_path__ + "static/120-min-min-f2cd2a7620573f54584389c27e743d4b.jpg";